import React from 'react';
import { Grid, Embed, Header, Segment } from 'semantic-ui-react';
import BasicSectionLayout from './SectionLayout';
import SectionHeaderLayout from './SectionHeaderLayout';

import { placeholderInterview, placeholderRealisation } from './imagesSections';

const interviewData = [
  { 
    idVideo: "k2DXFjkBChg",
    placeholder: placeholderInterview, 
    title: 'Interviews',
    text: `They give us their opinion on training. Interviews with some observers and trainers from the 2018 session.`
  },
  { 
    idVideo: "8BfXAPGwpaw",
    placeholder: placeholderRealisation, 
    title: 'Realisations',
    text: `Presentation of some projects carried out in 2018 by our young learners during the open day.`
  }
]

const InterviewVideo = ({ componentData }) => {
  return (
    <Grid.Column computer={5} tablet={7} stretched>
      <Segment className="videoWrapper">
        <Embed aspectRatio='16:9' 
          id={componentData.idVideo}
          iframe={{ allowFullScreen: true }}
          source="youtube"
          placeholder={componentData.placeholder} 
        />
        <Header as="h3" className="videoTitle"> {componentData.title} </Header>
        <p className="videoText"> {componentData.text} </p>
      </Segment>
    </Grid.Column>    
  )
}




const FifthSection = () => {
  return (
    <BasicSectionLayout sectionClasse="interviewContainer" fluide={true}>

      <Grid.Column computer={10} tablet={14} mobile={16} textAlign="center">
        <SectionHeaderLayout myhr={true}
          align ="center"
          headerclass="interviewTitle bigTitle"
          title="Interviews and achievements"
        >
          <p className="interviewText paragraph padded__text">
            Find the summary of the projects presented in 2018 during the open day and at the same 
            time the opinion of some observers and trainers
          </p> 
        </SectionHeaderLayout>

      </Grid.Column>

      <Grid.Row columns={3}>
        { interviewData.map((componentData) => {
          return (
            <InterviewVideo componentData={componentData}
              key={componentData.title}
            />)
        })}
      </Grid.Row>

    </BasicSectionLayout>
  );
}

export default FifthSection;